import { render, staticRenderFns } from "./SettingsUserModal.vue?vue&type=template&id=72802a57&lang=pug&"
import script from "./SettingsUserModal.vue?vue&type=script&lang=js&"
export * from "./SettingsUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports